export const btnSaveText = 'Save And Next'
export const btnLoadingText = 'Loading...'
export const btnDistributeText = 'Update'
export const keywordToDistributeComps = 'Fiona'
